import React from 'react';
import { cn } from '../../../utils';

type GameProviderStatus = 'active' | 'inactive' | 'maintenance' | 'unknown';

const STATUS_CONFIG: Record<
  GameProviderStatus,
  { label: string; className: string }
> = {
  active: {
    label: 'Active',
    className: 'bg-green-100 text-green-800 ring-1 ring-green-200/80',
  },
  inactive: {
    label: 'Inactive',
    className: 'bg-gray-100 text-gray-700 ring-1 ring-gray-200/80',
  },
  maintenance: {
    label: 'Maintenance',
    className: 'bg-amber-100 text-amber-900 ring-1 ring-amber-200/80',
  },
  unknown: {
    label: 'Unknown',
    className: 'bg-muted text-muted-foreground ring-1 ring-border/60',
  },
};

function normalizeStatus(status: string | null | undefined): GameProviderStatus {
  const raw = String(status ?? '').trim().toLowerCase();
  if (raw === 'active' || raw === 'inactive' || raw === 'maintenance') {
    return raw;
  }
  return 'unknown';
}

type Props = {
  status: string | null | undefined;
  className?: string;
};

export function GameProviderStatusBadge({ status, className }: Props) {
  const key = normalizeStatus(status);
  const config = STATUS_CONFIG[key];

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap',
        config.className,
        className,
      )}
      title={config.label}
    >
      {config.label}
    </span>
  );
}

export default GameProviderStatusBadge;
